import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  ConverterService,
  GlobalMessageService,
  GlobalMessageType,
  OccEndpointsService,
  UserIdService
} from '@spartacus/core'
import { of } from 'rxjs'
import { pluck, switchMap, take, tap } from 'rxjs/operators'
import {
  MB_CHECKOUT_BILLING_INFO_MODEL_NORMALIZER,
  MbCheckoutBillingAddressesAdapter
} from '../connectors'
import { ActiveCartService } from '@spartacus/cart/base/core'

@Injectable({
  providedIn: 'root',
})
export class MbOccCheckoutBillingAddressesAdapter implements MbCheckoutBillingAddressesAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService,
              protected userIdService: UserIdService,
              protected activeCartService: ActiveCartService,
              protected globalMessageService: GlobalMessageService) { }

  load () {
    return this.userIdService.getUserId().pipe(
      take(1),
      tap(userId => !userId && this.globalMessageService.add({ key: 'address.userError' }, GlobalMessageType.MSG_TYPE_ERROR)),
      switchMap(userId => userId && this.http.get(this.getEndpoint(userId)).pipe(
          pluck('addresses'),
          this.converter.pipeable(MB_CHECKOUT_BILLING_INFO_MODEL_NORMALIZER)
        ) || of([])
      )
    )
  }

  protected getEndpoint (userId: string) {
    return this.occEndpoints.buildUrl(
      'checkoutBillingAddresses',
      {
        urlParams: { userId }
      }
    )
  }
}
